import React from "react";

import {
  FiActivity,
  FiDownload,
  FiRefreshCw,
  FiRotateCw,
} from "react-icons/fi";

import {
  cn,
} from "../utils/siteActivityFormatters";

function formatRefreshTime(
  value,
) {
  if (!value) {
    return null;
  }

  try {
    return new Intl.DateTimeFormat(
      "fr-FR",
      {
        hour: "2-digit",
        minute: "2-digit",
      },
    ).format(value);
  } catch {
    return null;
  }
}

export default function SiteActivityHeader({
  dateStr,
  setDateStr,

  refreshing,
  criticalRefreshing,

  autoRefresh,
  setAutoRefresh,

  lastCriticalRefresh,

  onRefresh,
  onExport,
}) {
  const refreshTime =
    formatRefreshTime(
      lastCriticalRefresh,
    );

  return (
    <section className="overflow-hidden rounded-[30px] border border-slate-200 bg-gradient-to-r from-[#123B57] via-[#1C567F] to-[#2EA7E0] p-6 text-white shadow-sm lg:p-8">
      <div className="flex flex-col gap-5 2xl:flex-row 2xl:items-end 2xl:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-white/90">
            <FiActivity />

            Supervision des
            applications
          </div>

          <h1 className="mt-4 text-3xl font-bold tracking-tight lg:text-4xl">
            Suivi consolidé de
            toutes tes
            applications
          </h1>

          <p className="mt-3 max-w-4xl text-sm text-white/85 lg:text-base">
            Les notifications,
            messages et requêtes
            sont surveillés sur
            l’ensemble des sites.
            Les statistiques
            détaillées sont
            chargées uniquement
            pour la famille
            consultée afin
            d’éviter de saturer
            les API.
          </p>

          <div className="mt-4 flex flex-wrap gap-2 text-xs font-semibold text-white/75">
            <span className="rounded-full bg-white/10 px-3 py-1.5">
              Alertes auto :
              toutes les 2 min
            </span>

            <span className="rounded-full bg-white/10 px-3 py-1.5">
              Statistiques :
              toutes les 10 min
            </span>

            {refreshTime && (
              <span className="rounded-full bg-white/10 px-3 py-1.5">
                Dernière
                surveillance :{" "}
                {refreshTime}
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center 2xl:justify-end">
          <div className="rounded-2xl bg-white/10 p-2">
            <input
              type="date"
              value={dateStr}
              onChange={(
                event,
              ) =>
                setDateStr(
                  event.target
                    .value,
                )
              }
              className="w-full rounded-xl border border-white/10 bg-white px-3 py-2 text-sm font-semibold text-slate-900 outline-none sm:w-auto"
            />
          </div>

          <button
            type="button"
            onClick={
              onRefresh
            }
            disabled={
              refreshing ||
              criticalRefreshing
            }
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl bg-white/15 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-white/25",

              (refreshing ||
                criticalRefreshing) &&
                "cursor-not-allowed opacity-70",
            )}
          >
            <FiRefreshCw
              className={cn(
                (refreshing ||
                  criticalRefreshing) &&
                  "animate-spin",
              )}
            />

            Actualiser
          </button>

          <button
            type="button"
            onClick={() =>
              setAutoRefresh(
                (previous) =>
                  !previous,
              )
            }
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-semibold transition",

              autoRefresh
                ? "bg-white/15 text-white hover:bg-white/25"
                : "bg-black/20 text-white hover:bg-black/30",
            )}
          >
            <FiRotateCw />

            Auto :{" "}
            {autoRefresh
              ? "ON"
              : "OFF"}
          </button>

          <button
            type="button"
            onClick={
              onExport
            }
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-2.5 text-sm font-bold text-[#123B57] transition hover:bg-white/90"
          >
            <FiDownload />

            Export CSV
          </button>
        </div>
      </div>
    </section>
  );
}